import { createFileRoute } from "@tanstack/react-router";
import TradeIns from "@/pages/TradeIns";

export const Route = createFileRoute("/contact-us-trade-ins")({
  // ?UnitId=… variants collapse onto the clean trade-in URL.
  head: () => ({
    meta: [
      { title: "Trade In Your RV | Rex & Sons RVs" },
      { name: "description", content: "Get a trade-in value for your RV from Rex & Sons RVs in Castle Hayne, NC." },
      { property: "og:title", content: "Trade In Your RV | Rex & Sons RVs" },
      { property: "og:description", content: "Get a trade-in value for your RV from Rex & Sons RVs in Castle Hayne, NC." },
      { property: "og:url", content: "https://www.rexandsonsrvs.com/contact-us-trade-ins" },
    ],
    links: [{ rel: "canonical", href: "https://www.rexandsonsrvs.com/contact-us-trade-ins" }],
  }),
  component: TradeIns,
});
